import { styled } from 'twin.macro';

const MarkdownUnderline = styled.u``;

export default MarkdownUnderline;
